<template>
  <div>
    <label>Selecione os alváras abaixo que serão monitorados:</label>
    <label>Alvarás Default:</label>
    <b-form-group v-slot="{ ariaDescribedby }" v-if="filterTiposDefault && filterTiposDefault.length > 0">
      <b-form-checkbox-group id="checkbox-group-2" switches stacked v-model="selected"
        :aria-describedby="ariaDescribedby" name="flavour-2">
        <b-form-checkbox :value="tipo.id" v-for="tipo in filterTiposDefault" :key="tipo.id">{{ tipo.short_name ||
            tipo.tipo
        }}
          <b-button v-b-tooltip.hover.top title="Alterar Tipo" size="sm" v-if="tipo.user_id" variant="outline-secondary"
            @click.prevent="editTipo(tipo)"><i class="fas fa-edit"></i></b-button>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>

    <hr />
    <div class="d-flex align-items-center flex-wrap">
      <label>Alvarás Customizados</label>
      <b-button class="ml-2" variant="success" @click.prevent="title_edit_tipo = 'Cadastrar alvará customizado';edit_tipo = null;$bvModal.show('TipoFormModal')"><i class="fas fa-plus"></i>
        Cadastrar novo</b-button>
    </div>
    <b-form-group v-slot="{ ariaDescribedby }" v-if="filterTiposCustomizados && filterTiposCustomizados.length > 0">
      <b-form-checkbox-group id="checkbox-group-2" switches stacked v-model="selected"
        :aria-describedby="ariaDescribedby" name="flavour-2">
        <b-form-checkbox :value="tipo.id" v-for="tipo in filterTiposCustomizados" :key="tipo.id" stacked>
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ tipo.short_name || tipo.tipo }}</span>
            <b-button v-b-tooltip.hover.top title="Alterar nome do alvará" size="sm" v-if="tipo.user_id"
              variant="outline-secondary" @click.prevent="editTipo(tipo)"><i class="fas fa-edit"></i></b-button>
          </div>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>
    <modal size="md" :title="title_edit_tipo" id="TipoFormModal" btn_save form="TipoForm">
      <tipo-form :edit_tipo="edit_tipo" :colors="colors" :tipos="tipos" @getTipos="getTipos" />
    </modal>
  </div>
</template>

<script>
import TipoForm from "./TipoForm.vue";
export default {
  components: { TipoForm },
  props: {
    cliente_id: "",
    alvaras: Array,
    form_cliente: Boolean,
  },
  data() {
    return {
      selected: [],
      tipo_id: null,
      colors: [],
      tipos: [],
      edit_tipo: null,
      title_edit_tipo: '',
    };
  },

  watch: {
    selected(newValue, oldValue) {
      if (this.cliente_id && !this.form_cliente && newValue != oldValue) {
        this.ativarTipos();
      } else {
        this.$emit("updateAlvaras", this.selected);
      }
    },
    alvaras(newValue, oldValue) {
      if (newValue != oldValue) {
        this.getTipos();
      }
    },
  },

  created() {
    this.getTipos();
    this.getColors();
  },
  mounted() {
    if (this.alvaras) {
      let self = this;
      this.alvaras.map((alvara) => {
        if (alvara["status_id"] != 2) {
          if (!self.selected.find((item) => item == alvara["alvara_tipo"])) {
            self.selected.push(Number(alvara.alvara_tipo));
          }
        }
      });
    }
  },
  computed: {
    filterTiposDefault() {
      return this.tipos.filter((tipo) => !tipo.user_id);
    },
    filterTiposCustomizados() {
      return this.tipos.filter((tipo) => tipo.user_id);
    },
    filterColors() {
      return this.colors.filter(
        (color) => !this.tipos.some((tipo) => tipo.color_id == color.id)
      );
    },
  },
  methods: {
    editTipo(tipo) {
      this.title_edit_tipo = "Alterar alvará customizado";
      this.edit_tipo = tipo;
      this.$bvModal.show("TipoFormModal");
    },
    async getTipos() {
      const result = await this.$api.get("alvaras/tipos");
      this.tipos = result.data.tipos;
    },

    async ativarTipos() {
      await this.$api.put("alvaras/ativarTipos", {
        cliente_id: this.cliente_id,
        tipos: this.selected,
      });

      this.$emit("updateAlvaras");
    },
    async getColors() {
      const result = await this.$api.get("alvaras/colors");
      this.colors = result.data;
    },
  },
};
</script>
